import { Text } from "../../Components/atoms/Typography/Text/Text";
import { ActionButton } from "../../Components/molecules/ActionButton/ActionButton";

export const getColumns = (
  t,
  clickHandler,
  handlePriorityChange,
  totalRecords,
) => {
  let columndata = [
    {
      fieldtext: "Order",
      field: "priority",
      width: "120",
      textAlign: "Center",
      template: (props) => {
        const options = Array.from(
          { length: totalRecords || 5 },
          (_, i) => i + 1,
        );

        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <select
              value={props.priority || 1}
              onChange={(e) => {
                const newPriority = parseInt(e.target.value);
                if (newPriority !== props.priority && handlePriorityChange) {
                  handlePriorityChange(
                    props.generalRecordId,
                    newPriority,
                    props.attributeValue?.bannerName,
                  );
                }
              }}
              style={{
                padding: "6px 10px",
                borderRadius: "6px",
                border: "2px solid #e0e0e0",
                backgroundColor: "#fff",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
                minWidth: "70px",
                textAlign: "center",
                color: "#333",
                outline: "none",
                transition: "border-color 0.2s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#2196F3";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e0e0e0";
              }}
            >
              {options.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        );
      },
    },
    {
      fieldtext: "Banner ID",
      field: "generalRecordId",
      width: "180",
      textAlign: "Left",
      template: (props) => {
        const formattedId = (props.attributeValue?.bannerID || "No ID").replace(
          /\s+/g,
          "",
        );
        return <Text text={formattedId} />;
      },
    },
    {
      fieldtext: "Banner Name",
      field: "attributeValue.bannerName",
      width: "200",
      textAlign: "Left",
      template: (props) => {
        const bannerName = props.attributeValue?.bannerName || "No Name";
        return <Text text={bannerName} />;
      },
    },
    {
      fieldtext: "Created Date",
      field: "createdOn",
      width: "140",
      textAlign: "Left",
      enableGroupByFormat: true,
      template: (props) => {
        if (!props.createdOn) return <Text text="-" />;

        const date = new Date(props.createdOn);
        if (isNaN(date.getTime())) return <Text text="-" />;

        const formattedDate = `${date.getDate().toString().padStart(2, "0")}/${(
          date.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}/${date.getFullYear()}`;
        return <Text text={formattedDate} />;
      },
    },
    {
      fieldtext: "Actions",
      field: "actions",
      width: "88px",
      textAlign: "Left",
      allowSorting: false,
      headerTextAlign: "Left",
      template: (props) => {
        return (
          <ActionButton
            clickHandler={(e) => clickHandler(e, props)}
            Options={[
              {
                id: 1,
                element: <Text text="View" color={"blue.primaryBlue"} />,
              },
              // {
              //will use in future
              //   id: 2,
              //   element: (
              //     <Text
              //       text="Edit"
              //       color={"blue.primaryBlue"}
              //     />
              //   ),
              // },
              {
                id: 3,
                element: <Text text="Delete" color={"red.error"} />,
              },
            ]}
          />
        );
      },
    },
  ];
  return columndata;
};
